import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be8be9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-mobile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "home-mobile__title" }, " خرید و فروش تمام اتوماتیک تتر با بهترین قیمت ", -1))
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 mb-4 pb-2" }
const _hoisted_6 = { class: "col-12 mb-4 pb-2" }
const _hoisted_7 = { class: "col-12 mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tether_calculator = _resolveComponent("tether-calculator")!
  const _component_video_carousel = _resolveComponent("video-carousel")!
  const _component_latest_transactions = _resolveComponent("latest-transactions")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_tether_calculator)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_video_carousel)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_latest_transactions)
        ])
      ])
    ])
  ]))
}